import { useState } from 'react'
import { toast } from 'react-toastify';
import { Modal } from 'reactstrap';
import { IUser } from 'src/services/types';
import { deleteUser } from 'src/services/users-service';

interface IProps {
    show: boolean;
    onClose: () => void;
    onRefresh: () => void;
    user: IUser;
} 
export const ConfirmDeleteModal = ({ show, onClose, user, onRefresh }: IProps) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onDelete = async () => {
        setError('');
        setLoading(true);
        try {
            const res = await deleteUser(user.id);
            if (res.result === 'ok') {
                toast('User deleted successfully', { type: 'success'});
                onRefresh();
                onClose();
            } else {
                setError(res.message || 'An error has occurred, please try again later');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError('An error has occurred, please try again later');
        }
    }

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        size='md'   
    >
           <>
                <div className="modal-body">
                    <div className='col-sm-12 p-3'>
                        <div className='row mb-3 rounded py-2' style={{backgroundColor: '#fd625e1a'}}>
                            <h4 style={{color: '#000'}}>
                                Confirm Delete User
                            </h4>
                        </div>
                        <div className='row'>
                            <div className='col-sm-12'>
                                Are you sure you want to delete the user <b>{user?.firstName} {user?.lastName}</b>?
                            </div>
                        </div>
                    </div>
                    {
                        error  && 
                        <div className='col-sm-12 p-3'>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className='alert alert-danger' role='alert'>
                                        {error}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-soft-danger waves-effect waves-light"
                        onClick={() => onDelete()}
                    >
                        {
                           loading ? 
                            <><i className="fas fa-spinner fa-spin"></i> <span>Deleting...</span></>
                            : 'Yes, delete'
                        }
                    </button>
                    <button type="button" className="btn btn-soft-secondary" onClick={onClose}>
                        No, cancel
                    </button>
                </div>
            </>
    </Modal>
  )
}
